import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { evaluatePasswordRequirements } from 'shared/utils/passwordPolicy';

const PasswordRequirementsList = ({ password, showWhenEmpty = false }) => {
  const value = password ?? '';
  if (!showWhenEmpty && value.length === 0) {
    return null;
  }

  const requirements = evaluatePasswordRequirements(value);

  return (
    <Box sx={{ mt: 1 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        component="p"
        sx={{ mb: 0.75, fontWeight: 600 }}
      >
        Password must include:
      </Typography>
      <Box
        component="ul"
        sx={{
          m: 0,
          p: 0,
          listStyle: 'none',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: { xs: 1, sm: 1.25 },
          rowGap: 0.75,
        }}
      >
        {requirements.map((requirement) => (
          <Box
            component="li"
            key={requirement.id}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              color: requirement.met ? 'success.main' : 'text.secondary',
              whiteSpace: 'nowrap',
            }}
          >
            {requirement.met ? (
              <CheckCircleOutlineIcon sx={{ fontSize: 16, flexShrink: 0 }} />
            ) : (
              <RadioButtonUncheckedIcon sx={{ fontSize: 16, flexShrink: 0 }} />
            )}
            <Typography variant="caption" component="span" sx={{ lineHeight: 1.2 }}>
              {requirement.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PasswordRequirementsList;
